import React from "react";
interface BtnProps {
  children: React.ReactNode;
  handleClick?: () => void;
  className?: string;
  tabIndex?: number;
  disabled?: boolean
}
export default function FormButton(props: BtnProps) {
  const { children, handleClick, className, tabIndex, disabled } = props;


  return (
    <div>
      <button onClick={handleClick} className={`${className} cursor-pointer`} disabled={disabled} tabIndex={tabIndex}>
        {children}
      </button>
    </div>
  );
}
